module.exports = __webpack_public_path__ + "static/img/62995551.990c9517.png";